import { render, staticRenderFns } from "./HomeKitsDetailsItems.vue?vue&type=template&id=5cff97d7&scoped=true&"
import script from "./HomeKitsDetailsItems.vue?vue&type=script&lang=js&"
export * from "./HomeKitsDetailsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff97d7",
  null
  
)

export default component.exports